import { createSlice } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  allVendors: [],
  invitedVendors: [],
  error: null,
  loader: false,
  total: 0,
  last_page: 1,
  appointment: []
}

export const inviteVendorsSlice = createSlice({
  name: 'inviteVendors',
  initialState: initialState,
  reducers: {
    setAllVendors: (state, { payload }) => {
      state.allVendors = payload?.data;
    },
    setInvitedVendors: (state, { payload }) => {
      state.invitedVendors = payload?.data?.invites || payload?.data || [];
    },
    setAppointment: (state, { payload }) => {
      state.appointment = payload?.data;
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const fetchAppointmentsVendors = (id) => async (dispatch) => {
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchAppointmentsVendors(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAllVendors(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)
  }
  dispatch(setLoader(false))
}

export const fetchInvitedVendors = (id) => async (dispatch) => {
  dispatch(setLoader(true))
  try {
    const result = await Api.fetchInvitedVendors(id)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setInvitedVendors(result.data));
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)
  }
  dispatch(setLoader(false))
}

export const addInviteVendors = (data, itemId, callback) => async (dispatch) => {
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    const json = await Api.inviteVendors(itemId, data)
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    callback(false)
  }
  dispatch(setLoader(false))
};

export const { setAllVendors, setInvitedVendors, setAppointment, setLoader, setError } = inviteVendorsSlice.actions

export default inviteVendorsSlice.reducer
export const inviteVendorsSelector = state => state.inviteVendors
